import { app } from '../../../bootstrap/core';
import { SignoTecDebuggingFakeImage, SignoTecRequestTokens, SignoTecResponeTokens } from './signoTec.constants';
import { signoTecComponent } from './signoTec.component';
import { SignoTecService } from './signoTec.service';

app.component('signoTec', signoTecComponent)
  .service('signoTecService', SignoTecService)
  .constant('fakeSignature', SignoTecDebuggingFakeImage)
  .constant('signoTecRequestTokens', SignoTecRequestTokens)
  .constant('signoTecResponeTokens', SignoTecResponeTokens);
